import { BadgeProps } from "@minuthq/meatball-ui-react"

export function getStockBadgeColor({
  stockQuantity,
  lowStockThreshold,
  outOfStockThreshold,
}: {
  stockQuantity: number
  lowStockThreshold: number
  outOfStockThreshold: number
}): BadgeProps["color"] {
  if (stockQuantity > lowStockThreshold) {
    return "good"
  }

  if (
    stockQuantity > outOfStockThreshold &&
    stockQuantity <= lowStockThreshold
  ) {
    return "warning"
  }

  return "error"
}
